module.exports = __webpack_public_path__ + "img/sao-paulo-mania-online.e494d8ff.svg";